import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import CookieIcon from '../icons/CookieIcon';
import ZaraButton from '../buttons/Button';

const MobileBlank = ({ acceptCookies, openNewTab }) => {
    return (
        <Flex
            css={{
                '@media only screen and (max-width: 450px)': {
                    display: 'flex',
                },
                '@media only screen and (min-width: 500px)': {
                    display: 'none',
                },
            }}
            className='cookie'
            p='20px 40px'
            alignItems='center'
            bg='#858585'
            w='100%'
            pos='absolute'
            bottom='0px'
            zIndex={30}
        >
            <Box
                p='24px 24px 0px 24px'
                w='100%'
                color='white'
                fontSize='16px'
                fontWeight='400'
                lineHeight='20px'
                letterSpacing='0em'
                textAlign='left'
            >
                <Flex justifyContent='center' mb='20px'>
                    <Flex
                        margin='0px auto'
                        justifyContent='center'
                        alignItems='center'
                        h='42px'
                        w='42px'
                        borderRadius='12px'
                        p='10px'
                        bg='white'
                    >
                        <CookieIcon />
                    </Flex>
                </Flex>
                <Text>
                    We use cookies to customize to your needs and enhance your experience. Cookies are only used to help
                    provide services and can be refused by changing your browser settings. By continuing to use the
                    service, you agree to our use of cookies as described{' '}
                    <Text display='inline' textDecoration='underline' onClick={openNewTab}>
                        the Cookie Policy.
                    </Text>
                </Text>
                <Flex mt='20px' justifyContent='center'>
                    <ZaraButton
                        w='100%'
                        onClick={acceptCookies}
                        variant='successOutline'
                        border='none'
                        color='#5611F8'
                        _hover={{ bg: 'white', textDecoration: 'underline' }}
                        _active={{ bg: 'white' }}
                    >
                        Agree
                    </ZaraButton>
                </Flex>
            </Box>
        </Flex>
    );
};

export default MobileBlank;
